import { FlexColumnCenter, FlexStartRow } from '../common/forms/FormElements';

const flattenAnswers = (answers) => {
    if ((answers ?? []).length <= 0) return [];

    // First, flatten down the response types.
    const mappedAns = [...answers].map((a) => ({
        questionId: a.questionId,
        questionName: a.questionName,
        answerBoolean: a.answerBoolean,
        answerFloat: a.answerFloat,
        answerInt: a.answerInt,
        answerText:
            /*
                RLC 2/4/22 - TODO: This needs to be expanded out to also print
                                decimal/number answers when we support them. NBD, just
                                need to consider formatting.
            */
            a.answerText
            ?? /* Typed answer */ a.questionOptionChoiceText /* Fall back to answer selection from drop down */,
    }));

    // Then merge the answers for display.
    const flattened = mappedAns.reduce((prev, curr) => {
        const existingIndex = prev.findIndex((x) => x.questionId === curr.questionId) ?? -1;
        if (existingIndex > -1) {
            // update the item in place.  concatenates choice option text for multiple choice options, for display.
            prev[existingIndex].answerText += `, ${curr.answerText}`;
        } else {
            prev.push(curr);
        }
        return prev;
    }, []);

    return flattened;
};

export const Answers = ({ answers }) => {
    if (!answers) return null;

    const flattenedAnswers = flattenAnswers([...answers]) ?? [];

    if (flattenedAnswers.length > 0) {
        return flattenedAnswers.map((ans, ansInx) => (
            <FlexColumnCenter
                className="mt-2 ml-3 mb-2"
                key={ansInx}
            >
                <FlexStartRow className="border-bottom">
                    <small className="font-weight-bold text-info">
                        {ans.questionName.toUpperCase()}
                    </small>
                </FlexStartRow>

                <FlexStartRow className="pt-1">
                    <small>{ans.answerText}</small>
                </FlexStartRow>
            </FlexColumnCenter>
        ));
    }
    return null;
};